"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var ModelBase_1 = require("./ModelBase");
var Field_1 = require("../constants/Field");
var lodash_1 = require("lodash");
var ComputeFunction_1 = require("./computeType/ComputeFunction");
var ComputeModelBase_1 = require("./computeType/ComputeModelBase");
var MappingModel_1 = require("./mapping/MappingModel");
var Objects_1 = require("../api/Objects");
var DataType_1 = require("./common/base/DataType");
var ComputeAttributes_1 = require("./computeType/ComputeAttributes");
var Alarms_1 = require("./computeType/alarm/Alarms");
var axios_1 = tslib_1.__importDefault(require("axios"));
var SceProperties = /** @class */ (function () {
    function SceProperties() {
        this.outputInitialPath = '#/properties/functions/';
        this.storageVariables = [];
        this.attributes = new ComputeAttributes_1.ComputeAttributes();
    }
    SceProperties.fromJson = function (json, isInstance) {
        var properties = new SceProperties();
        properties.category = json.category;
        properties.saveOption = json.saveOption.value;
        properties.associatedObjectType = ModelBase_1.ModelBase.fromJson(json.associatedObjectType);
        properties.model = ComputeModelBase_1.ComputeModelBase.fromJson(json.model);
        var ids = this.getAvailableObjectInstanceIds(json.objectInstances);
        properties.functions = SceProperties.fromJsonToFunctions(json[Field_1.FIELD.FUNCTIONS], isInstance, ids);
        properties.alarms = Alarms_1.Alarms.fromJson(json.alarms);
        properties.addAlarmVariables();
        properties.objectIds = json.objectIds;
        return properties;
    };
    SceProperties.fromJsonToFunctions = function (functionsJson, isInstance, objectInstanceIds) {
        var functions = lodash_1.map(Object.keys(functionsJson), function (functionName) {
            return ComputeFunction_1.ComputeFunction.fromJson(functionName, functionsJson[functionName], isInstance, objectInstanceIds);
        });
        return functions;
    };
    SceProperties.getAvailableObjectInstanceIds = function (objectInstances) {
        if (objectInstances === undefined) {
            return [];
        }
        if (lodash_1.isEmpty(objectInstances)) {
            return [];
        }
        return Object.keys(objectInstances);
    };
    /**
     * Creates Compute Type Json if isInstance is false else will create Instance Json
     * @param isInstance is json object to be created an instance
     */
    SceProperties.prototype.toTypeJson = function () {
        var json = Object.create(null);
        json = Object.assign(json, this.model.toTypeJson());
        var storage = this.storageVariablesToJson(false);
        var propertiesJson = Object.create(null);
        if (!lodash_1.isEmpty(storage)) {
            propertiesJson[Field_1.FIELD.STORAGE] = storage;
        }
        var functions = Object.create(null);
        lodash_1.map(this.functions, function (computeFunction) {
            functions = Object.assign(functions, computeFunction.toJson(false));
        });
        propertiesJson[Field_1.FIELD.FUNCTIONS] = functions;
        if (this.alarms) {
            propertiesJson[Field_1.FIELD.ALARMS] = this.alarms.toJson(false);
        }
        json[Field_1.FIELD.PROPERTIES] = propertiesJson;
        json[Field_1.FIELD.ATTRIBUTES] = this.attributes.toJson();
        return json;
    };
    SceProperties.prototype.toInstanceJson = function (objectId) {
        var json = Object.create(null);
        json = Object.assign(json, this.model.toInstanceJson());
        json[Field_1.FIELD.OBJECTID] = objectId;
        var storage = this.storageVariablesToJson(true);
        var propertiesJson = Object.create(null);
        if (!lodash_1.isEmpty(storage)) {
            propertiesJson[Field_1.FIELD.STORAGE] = storage;
        }
        var functions = Object.create(null);
        lodash_1.map(this.functions, function (computeFunction) {
            functions = Object.assign(functions, computeFunction.toJson(true));
        });
        propertiesJson[Field_1.FIELD.FUNCTIONS] = functions;
        if (this.alarms) {
            propertiesJson[Field_1.FIELD.ALARMS] = this.alarms.toJson(true);
        }
        json[Field_1.FIELD.PROPERTIES] = propertiesJson;
        return json;
    };
    /**
     * Fetches MappingModel from cloud if already available else creates a new one
     * @returns MappingModel. ObjectId will be undefined in case of newly created mapping model
     */
    SceProperties.prototype.fetchMappings = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, model, typeId, version, mappings, error_1, mappingModel;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.associatedObjectType, model = _a.model, typeId = _a.typeId, version = _a.version;
                        if ((!model) || (!typeId) || (!version)) {
                            throw new Error('model/typeId/version of associatedObjectType can\'t be undefined or null');
                        }
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 5]);
                        return [4 /*yield*/, this.fetchExistingMappingModel(typeId.value, version.value)];
                    case 2:
                        mappings = _b.sent();
                        return [2 /*return*/, mappings];
                    case 3:
                        error_1 = _b.sent();
                        return [4 /*yield*/, this.createNewMappingModel()];
                    case 4:
                        mappingModel = _b.sent();
                        return [2 /*return*/, mappingModel];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Deletes all available model instances with objectIds in {this.objectIds}
     */
    SceProperties.prototype.deleteModelInstances = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var promises;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        promises = lodash_1.map(this.objectIds.value, function (objectId) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            return tslib_1.__generator(this, function (_a) {
                                try {
                                    //  await this._cosmosDbApi.deleteModel(objectId, ModelConstants.SceInstanceModel, this.model.model.value);
                                }
                                catch (_b) {
                                    return [2 /*return*/];
                                }
                                return [2 /*return*/];
                            });
                        }); });
                        return [4 /*yield*/, axios_1.default.all(promises)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Adds alarm variables to output conditions if they are defined in alarms
     */
    SceProperties.prototype.addAlarmVariables = function () {
        var _this = this;
        if (this.alarms === undefined) {
            return;
        }
        lodash_1.map(this.alarms.sceAlarms, function (sceAlarm) {
            var computeFunction = lodash_1.find(_this.functions, { name: sceAlarm.functionName });
            lodash_1.map(sceAlarm.alarms, function (alarm) {
                if (computeFunction !== undefined) {
                    var alarmVariable = alarm.getAlarmConditionVariable();
                    computeFunction.outputs.addAlarm(alarm.alarmName, alarmVariable);
                }
            });
        });
    };
    SceProperties.prototype.fetchExistingMappingModel = function (typeId, version) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var objects, mappings;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        objects = new Objects_1.Objects();
                        return [4 /*yield*/, objects.getMappingsByVersion('abb.ia.deviceType.mapping', typeId, version)];
                    case 1:
                        mappings = _a.sent();
                        if (mappings.data.data.length === 0) {
                            throw new Error('Mappings not found');
                        }
                        return [2 /*return*/, MappingModel_1.MappingModel.fromJson(mappings.data.data[0])];
                }
            });
        });
    };
    SceProperties.prototype.createNewMappingModel = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var mappingModel;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, MappingModel_1.MappingModel.createNewMappingModel(this.associatedObjectType.typeId.value, this.associatedObjectType.version.value, this.associatedObjectType.model, this.associatedObjectType.version)];
                    case 1:
                        mappingModel = _a.sent();
                        return [2 /*return*/, mappingModel];
                }
            });
        });
    };
    /**
     * Creates storage variables using input variables.
     * Converts Storage variables to json
     * @returns json
     */
    SceProperties.prototype.storageVariablesToJson = function (includeOnlyValueOrLink) {
        this.createStorageVariables();
        var json = Object.create(null);
        lodash_1.map(this.storageVariables, function (storageVariable) {
            var storageDataItemJson = storageVariable.toJson(includeOnlyValueOrLink);
            if (!storageDataItemJson[Field_1.FIELD.VALUE]) {
                storageDataItemJson[Field_1.FIELD.VALUE] = storageVariable.getDefaultItemValue(false);
            }
            json[storageVariable.name] = storageDataItemJson;
        });
        return json;
    };
    SceProperties.prototype.createStorageVariables = function () {
        var _this = this;
        var storageVariables = [];
        lodash_1.map(this.functions, function (computeFunction) {
            storageVariables = storageVariables.concat(_this.getStorageVariablesForFunction(computeFunction));
        });
        if (storageVariables.length > 0) {
            this.storageVariables = storageVariables;
        }
    };
    SceProperties.prototype.getStorageVariablesForFunction = function (computeFunction) {
        var inputs = computeFunction.inputs.inputs;
        return this.getStorageVariablesForInputVariables(inputs);
    };
    /**
     * Creates storage variable using input variable if it is pointing to any output.
     * To be used for non-array input
     * @param inputVariable Input variable to be used to create storage variable
     */
    SceProperties.prototype.createStorageVariableForNonArrayVariable = function (inputVariable) {
        var matchedFunction = this.getAssetMonitorFunctionWithReferencedOutput(inputVariable.link);
        if (matchedFunction === undefined) {
            return undefined;
        }
        return matchedFunction.createStorageVariable(inputVariable.link, inputVariable);
    };
    /**
     * Creates storage variables using input variable if its link(any or all of
     * stringified array of links) is pointing to any output.
     * To be used for input with array datatype
     * @param inputVariable Input variable to be used to create storage variables
     */
    SceProperties.prototype.createStorageVariablesForArrayVariable = function (input) {
        var _this = this;
        var storageVariables = [];
        if (!input.link && (input.link === '')) {
            return storageVariables;
        }
        var links = [];
        try {
            links = JSON.parse(input.link);
        }
        catch (error) {
            return storageVariables;
        }
        lodash_1.map(links, function (link) {
            var matchedFunction = _this.getAssetMonitorFunctionWithReferencedOutput(link);
            if (matchedFunction === undefined) {
                return;
            }
            var storageVariable = matchedFunction.createStorageVariable(link, input);
            if (storageVariable) {
                storageVariables.push(storageVariable);
            }
        });
        return storageVariables;
    };
    /**
     * Will check if given link is a link/reference path to an output.
     * If yes, will return the name of function which has the output
     * * Prerequisite: All compute functions should have unique names
     * @param link link path
     */
    SceProperties.prototype.getAssetMonitorFunctionWithReferencedOutput = function (link) {
        var functionName = this.getFunctionNameFromInputVariableLinkPath(link);
        if (functionName === undefined) {
            return undefined;
        }
        return lodash_1.find(this.functions, { name: functionName });
    };
    /**
     *
     * @param link
     * @returns {string} FunctionName if found matching path else undefined
     */
    SceProperties.prototype.getFunctionNameFromInputVariableLinkPath = function (link) {
        if (link === undefined) {
            return undefined;
        }
        var initialPath = link.slice(0, 23);
        if (initialPath !== this.outputInitialPath) {
            return undefined;
        }
        var endPathElements = link.slice(23).split('/');
        if (endPathElements.length === 3 && endPathElements[1] === 'outputs') {
            return endPathElements[0];
        }
        return undefined;
    };
    SceProperties.prototype.getStorageVariablesForInputVariables = function (inputVariables) {
        var _this = this;
        var storageVariables = [];
        lodash_1.map(inputVariables, function (inputVariable) {
            if (inputVariable.dataType === DataType_1.DataType.array) {
                var storageVariablesForLinkedVariable = _this.createStorageVariablesForArrayVariable(inputVariable);
                storageVariables = storageVariables.concat(storageVariablesForLinkedVariable);
            }
            else {
                var storageVariable = _this.createStorageVariableForNonArrayVariable(inputVariable);
                if (storageVariable !== undefined) {
                    storageVariables.push(storageVariable);
                }
            }
        });
        return storageVariables;
    };
    return SceProperties;
}());
exports.SceProperties = SceProperties;
//# sourceMappingURL=SceProperties.js.map